import { Link } from "react-router-dom"
import EmptyMessage from "@/components/common/EmptyMessage"
import Loading from "@/components/common/Loading"
import StatusBadge from "@/components/common/StatusBadge"
import { sportLabel } from "@/domain/fight/model/Fight"
import { useTournamentList } from "@/domain/tournament/hooks/TournamentListHook"

export default function TournamentListPage() {
  const { useTournamentListState } = useTournamentList()
  const { tournaments, isLoaded, errorMessage } = useTournamentListState()

  return (
    <section className="app-page">
      <div className="app-page-head">
        <p className="app-txt-eyebrow text-app-primary-600">TOURNAMENTS</p>
        <h1 className="app-txt-h1 mt-3">대회 목록</h1>
        <p className="app-txt-body2 mt-3 leading-6 text-app-text-300">
          접수 중인 대회를 골라 체육관 단위로 참가 신청할 수 있습니다.
        </p>
      </div>

      {!isLoaded && <Loading label="대회 목록을 불러오는 중" />}

      {isLoaded && errorMessage && (
        <p
          role="alert"
          className="app-alert app-alert-error"
        >
          {errorMessage}
        </p>
      )}

      {isLoaded && !errorMessage && tournaments.length === 0 && (
        <EmptyMessage message="조회된 대회가 없습니다." />
      )}

      {isLoaded && tournaments.length > 0 && (
        <ul className="app-grid-hairline list-none md:grid-cols-2 xl:grid-cols-3">
          {tournaments.map((tournament) => (
            <li
              key={tournament.id}
              className="flex flex-col"
            >
              <div className="flex items-start justify-between gap-3">
                <h2 className="app-txt-h3">
                  <Link
                    to={`/tournaments/${tournament.id}`}
                    className="focus-ring hover:text-app-primary-600"
                  >
                    {tournament.name}
                  </Link>
                </h2>
                <StatusBadge
                  label={tournament.statusLabel}
                  className="shrink-0"
                />
              </div>

              <dl className="mt-5 grid flex-1 content-start gap-3 border-t border-app-secondary-300 pt-5">
                <div className="flex gap-3">
                  <dt className="app-txt-body2 w-20 shrink-0 text-app-text-200">
                    장소
                  </dt>
                  <dd className="app-txt-body2 text-app-text-400">
                    {tournament.venue}
                  </dd>
                </div>
                <div className="flex gap-3">
                  <dt className="app-txt-body2 w-20 shrink-0 text-app-text-200">
                    대회일
                  </dt>
                  <dd className="app-txt-body2 text-app-text-400">
                    {tournament.periodText}
                  </dd>
                </div>
                <div className="flex gap-3">
                  <dt className="app-txt-body2 w-20 shrink-0 text-app-text-200">
                    접수 마감
                  </dt>
                  <dd className="app-txt-body2 text-app-text-400">
                    {tournament.entryCloseText}
                  </dd>
                </div>
                <div className="flex gap-3">
                  <dt className="app-txt-body2 w-20 shrink-0 text-app-text-200">
                    개최 종목
                  </dt>
                  <dd className="app-txt-body2 text-app-text-400">
                    {tournament.sports.map(sportLabel).join(", ")}
                  </dd>
                </div>
              </dl>

              {tournament.isEntryOpen && (
                <Link
                  to={`/application?tournamentId=${tournament.id}`}
                  className="focus-ring app-btn app-btn-primary app-btn-block mt-6"
                >
                  참가신청
                </Link>
              )}
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}
